module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-Rear_2.4e1dddf4.jpg";